import {Component, forwardRef, ChangeDetectorRef, Injector, Input} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CodeScannerModel } from '../code-scanner.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { PlatformService } from 'src/app/core-api/platform/platform.service';

@Component({
    selector: 'abw-code-scanner-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CodeScannerFormComponent),
        multi: true
      }
    ],
    templateUrl: './code-scanner-form.component.html',
    styleUrls: ['./code-scanner-form.component.scss']
})
export class CodeScannerFormComponent extends AbstractWorkflowFormComponent<CodeScannerModel, string> {
  @Input() standalone = false;
  
  constructor(
      private platformService: PlatformService,
      _workflowComponentsService: WorkflowComponentsService,
      _cdf: ChangeDetectorRef,
      _injector: Injector
  ) {
      super(_workflowComponentsService, _cdf, _injector);
  }
  
  async scanCode() {
    try {
      const result = await this.platformService.scanQRCode();
      this.onValueChanged(result);
    } catch(e) {
      console.error(e);
    }
  }
}